<template>
    <div id="app">
        <div class="bodyWrap">
            <a-spin :spinning="spinning" tip="Loading..." >
                <div class="headerNav" v-if="equipment=='mobile'">
                    <HeaderMobile />
                </div>
                <Header v-else />
                <div class="Mobile" v-if="equipment=='mobile'">
                    <router-view />
                </div>
                <div class="Computer" v-else>
                    <router-view />
                </div>
            </a-spin>
        </div>
    </div>
</template>
<script>
import Header from '@/components/Header/index.vue'
import HeaderMobile from '@/components/HeaderMobile/index.vue'
import { mapState } from "vuex";
export default {
    data() {
        return {
        };
    },

    components: {Header,HeaderMobile},

    computed: {
        ...mapState({
            spinning: state => state.loading.loaddingSpin,
            equipment:state => state.equipment.equipment,
        })
    },

    created() {
    },

    mounted() {
        console.log(this.equipment)
    },

    methods: {

    },
};
</script>
<style lang="less" scoped>
.bodyWrap{
    padding-top:64PX;
    font-size: medium;
    line-height: normal;
}
/deep/ .ant-spin{
  background: rgba(0, 0, 0, .6);
  min-height: 100vh;
  .ant-spin-text{
    text-shadow: none !important;
  }
}
.headerNav {
    position: fixed;
    top: 0;
    z-index: 999;
    width:100%;
}
@media screen and (max-width: 768px) {
    .bodyWrap {
        padding-top: 2.1rem;
    }
}
</style>

